<template>
  <div class="flex -mx-2 mt-4 md:max-w-md">
    <div class="p-2 w-1/2">
      <button
        v-if="showBackPage"
        type="button"
        class="opacity-50 md:w-48 flex justify-between items-center w-full text-left border-4 border-white p-3 my-2 text-2xl font-bold font-display leading-tight focus:outline-none focus:border-orange-700"
        @click="back"
      >
        <span>Back</span>
        <span>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 22 22"
            class="w-8 h-8"
          >
            <path
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              d="M1 1h20v20H1z"
            />
            <path
              fill="currentColor"
              d="M11.8 16.5c-.3.3-.7.3-.9 0l-5.3-5.3c-.3-.3-.3-.7 0-.9L10.9 5c.3-.3.7-.3.9 0l.6.6c.3.3.3.7 0 .9L9.1 9.7H17c.4 0 .7.3.7.7v.9c0 .4-.3.7-.7.7H9.1l3.3 3.1c.3.3.3.7 0 .9l-.6.5z"
            />
          </svg>
        </span>
      </button>
    </div>
    <div class="p-2 w-1/2">
      <button
        type="button"
        class="md:w-48 flex justify-between items-center w-full text-left border-4 border-white p-3 my-2 text-2xl font-bold font-display leading-tight focus:outline-none focus:border-orange-700"
        @click="handleNext(next, $event)"
      >
        <template v-if="isLastPage">
          <span>Finish</span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 496 512"
              class="w-8 h-8"
            ><path
              fill="currentColor"
              d="M248 8C111 8 0 119 0 256s111 248 248 248 248-111 248-248S385 8 248 8zm63.7 128.7c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zm-160 0c7.6-11.4 24.7-11.7 32.7 0 12.4 18.4 15.1 36.9 15.7 55.3-.5 18.4-3.3 36.9-15.7 55.3-7.6 11.4-24.7 11.7-32.7 0-12.4-18.4-15.1-36.9-15.7-55.3.5-18.4 3.3-36.9 15.7-55.3zM248 432c-60.6 0-134.5-38.3-143.8-93.3-2-11.8 9.3-21.6 20.7-17.9C155.1 330.5 200 336 248 336s92.9-5.5 123.1-15.2c11.4-3.7 22.6 6.1 20.7 17.9-9.3 55-83.2 93.3-143.8 93.3z"
            /></svg>
          </span>
        </template>
        <template v-else>
          <span>Next</span>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 22 22"
              class="w-8 h-8"
            >
              <path
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                d="M1 1h20v20H1z"
              />
              <path
                fill="currentColor"
                d="M11.2 5c.3-.3.7-.3.9 0l5.3 5.3c.3.3.3.7 0 .9l-5.3 5.3c-.3.3-.7.3-.9 0l-.6-.6c-.3-.3-.3-.7 0-.9l3.3-3.1H6c-.4 0-.7-.3-.7-.7v-.9c0-.4.3-.7.7-.7h7.9l-3.3-3.1c-.3-.3-.3-.7 0-.9l.6-.6z"
              />
            </svg>
          </span>
        </template>
      </button>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapGetters } = createNamespacedHelpers('survey')

export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'shownPages',
      'currentPage',
      'directions',
      'survey'
    ]),
    currentPageIndex () {
      return this.shownPages.findIndex(page => page.id === this.currentPage)
    },
    isLastPage () {
      return (this.currentPageIndex + 1) >= this.shownPages.length
    },
    isFirstPage () {
      return (this.currentPageIndex - 1) < 0
    },
    showBackPage () {
      const defaultSurveysHashes = [
        process.env.VUE_APP_SURVEY_1_HASH,
        process.env.VUE_APP_SURVEY_2_HASH,
        process.env.VUE_APP_SURVEY_3_HASH
      ]

      let isDefaultSurvey = (defaultSurveysHashes.indexOf(this.survey.hash) !== -1)

      if (isDefaultSurvey) {
        return true
      }

      return this.currentPageIndex !== 0
    }
  },
  methods: {
    findAncestor (el, cls) {
      while ((el = el.parentElement) && !el.classList.contains(cls));
      return el
    },
    scrollToFirstError () {
      this.$nextTick(() => {
        let elementsInErrors = document.querySelectorAll('.validation-failed')
        if (elementsInErrors && elementsInErrors.length > 0) {
          let itemContainer = this.findAncestor(elementsInErrors[0], 'item-container')
          if (itemContainer) {
            itemContainer.scrollIntoView()
          }
        }
      })
    },
    handleNext (next, event) {
      if (event) {
        event.target.blur()
      }

      this.handleSubmit(next).then(() => {
        this.scrollToFirstError()
      })
    },
    next (event) {
      window.scrollTo(0, 0)
      this.$store.commit('survey/CURRENT_DIRECTION_UPDATED', this.directions.NEXT)

      if (this.isLastPage) {
        this.$store.dispatch('survey/submitSurvey')
      } else {
        let currentPageId = this.shownPages[this.currentPageIndex].id
        let nextPageId = this.shownPages[this.currentPageIndex + 1].id
        this.$store.dispatch('survey/submitSurveyPage', currentPageId)
        this.$store.commit('survey/CURRENT_PAGE_UPDATED', nextPageId)
      }
    },
    back (event) {
      if (event) {
        event.target.blur()
      }

      window.scrollTo(0, 0)
      this.$store.commit('survey/CURRENT_DIRECTION_UPDATED', this.directions.PREV)

      if (this.isFirstPage) {
        this.$router.push({ name: 'home' })
      } else {
        let previousPage = this.shownPages[this.currentPageIndex - 1].id
        this.$store.commit('survey/CURRENT_PAGE_UPDATED', previousPage)
      }
    }
  }
}
</script>
